import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

import { AlertService } from './alert.service'
import { AppService } from './app.service'
import { ToastService } from './toast.service'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class PromoCodeService extends AppService {
    constructor(
        protected override http: HttpClient,
        toastService: ToastService,
        translate: TranslateService,
        alertService: AlertService
    ) {
        super(http, toastService, translate, alertService)
    }

    /**
     * Get all promo codes with optional filters
     */
    getPromoCodes(filters?: any): Observable<any> {
        const params = new URLSearchParams()

        if (filters) {
            Object.keys(filters).forEach(key => {
                if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                    params.append(key, filters[key].toString())
                }
            })
        }

        const queryString = params.toString()
        const url = queryString ? `promo-codes?${queryString}` : 'promo-codes'

        return this.get<any>(url)
    }

    /**
     * Get promo code by ID
     */
    getPromoCodeById(id: number): Observable<any> {
        return this.get<any>(`promo-codes/${id}`)
    }

    /**
     * Create a new promo code
     */
    createPromoCode(data: any): Observable<any> {
        return this.post<any>('promo-codes', data)
    }

    /**
     * Update an existing promo code
     */
    updatePromoCode(id: number, data: any): Observable<any> {
        return this.put<any>(`promo-codes/${id}`, data)
    }

    /**
     * Delete a promo code
     */
    deletePromoCode(id: number): Observable<any> {
        return this.delete<any>(`promo-codes/${id}`)
    }

    /**
     * Add memberships to promo code
     */
    addMembershipsToPromoCode(id: number, membershipIds: number[]): Observable<any> {
        return this.post<any>(`promo-codes/${id}/memberships`, { membershipIds })
    }

    /**
     * Get memberships linked to promo code
     */
    getMembershipsByPromoCode(id: number): Observable<any> {
        return this.get<any>(`promo-codes/${id}/memberships`)
    }

    /**
     * Remove one membership from promo code
     */
    removeMembershipFromPromoCode(id: number, membershipId: number): Observable<any> {
        return this.delete<any>(`promo-codes/${id}/memberships/${membershipId}`)
    }

    /**
     * Disable a promo code
     */
    disablePromoCode(id: number): Observable<any> {
        return this.put<any>(`promo-codes/${id}/disable`, {})
    }

    /**
     * Enable a promo code
     */
    enablePromoCode(id: number): Observable<any> {
        return this.put<any>(`promo-codes/${id}/enable`, {})
    }
}
